import React, { useState , useEffect } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import OpenAiIM from '../../../assets/images/openai.png';
import TopHeaderPanel from '../TopHeaderPanel';
import { useSelector } from 'react-redux';
import Bottom_input from '../Bottom_input';
import Top_input from '../Top_input';


const OpenAINode = ({ id, data }) => {
  const label = data?.label || 'OpenAI';
  const { setNodes } = useReactFlow()
  const [Instruction, setInstruction] = useState(data.node_data.node_input[0].instruction.input_data)
  const [model, setmodel] = useState(data.node_data.node_input[1].model.input_data)
  const { Model_List } = useSelector((state) => state.Create_Bot)
  const [selected_input_param, setselected_input_param] = useState(data.node_data.node_input[2].taken_input_from)
  const [selected_output_param, setselected_output_param] = useState(data.node_data.node_input[3].send_output_to)


  useEffect(() => {
    //  console.log(data.node_data.node_input[1].model.input_data)
     setmodel(data.node_data.node_input[1].model.input_data)
  }, [data])
  
  
  const handleChangeInstruction = (e) => {
    const newValue = e.target.value;
    setInstruction(newValue)

    // console.log(data)
    // Update the Input Value 
    let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
    node_data_temp.node_input[0].instruction.input_data=newValue
    // The output processing will be done at backend . 
    // node_data_temp.node_output=node_data_temp.node_input

    

    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
  };


  const handleChangeModel = (e) => {
    // console.log(e.target.value,"model value")
    
    const newValue = e.target.value;
    setmodel(newValue)

    // console.log(data)
    // Update the Input Value 
    let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
    node_data_temp.node_input[1].model.input_data=newValue
    // The output processing will be done at backend . 
    // node_data_temp.node_output=node_data_temp.node_input

    

    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
  };


    const onchange_selected_input_param=(e)=>{
      setselected_input_param(e.target.value)
      let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[2].taken_input_from=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }

      const onchange_selected_output_param=(e)=>{
      setselected_output_param(e.target.value)


            let node_data_temp = JSON.parse(JSON.stringify(data.node_data));
      node_data_temp.node_input[3].send_output_to=e.target.value
          setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                node_data:node_data_temp
              },
            }
          : node
      )
    );
   }

// Set model list .


  return (
    <div className='node-style'>
      <div className='thpw'>
      {data.selectedNodeId === id && <TopHeaderPanel />}
      </div>
      
      <div className="node">
        <div className='node_head'>
          <img src={OpenAiIM} style={{ width: '15px', marginRight: '5px' }} alt="OpenAI" />
          {label}
          <i className="mdi mdi-close" onClick={(e) => {
            e.stopPropagation();
            if (data?.onDelete) {
              data.onDelete(id);
            }
          }}></i>
          <p>Generates text using OpenAI LLMs.</p>
        </div>

        <div className='node_body'>
          <Top_input selected_params={selected_input_param} onchange_selected_input_param={onchange_selected_input_param} />
          <div>
            <label>Model Name</label>
             <select
                  onChange={handleChangeModel}
                  className="form-select"
                  aria-label=".form-select-sm example"
              >
                {Object.entries(
                Model_List.reduce((acc, ele) => {
                    if (!acc[ele.Provider]) acc[ele.Provider] = [];
                    acc[ele.Provider].push(ele);
                    return acc;
                }, {})
                ).map(([provider, models]) => (
                <optgroup label={provider} key={provider}>
                    {models.map((ele) => (
                    <option 
                        selected={ele.ModelVersion === model.trim()} 
                        value={ele.ModelVersion} 
                        key={ele.ModelID}
                    >
                        {ele.ModelVersion}
                    </option>
                    ))}
                </optgroup>
                ))}
            </select>
            <Handle type="target" position={Position.Left} id="input" style={{ top: '55%' }} />
          </div>
          
          {/* 
            <div>
              <label>API Key</label>
              <input placeholder="API Key" defaultValue={apiKey} />
              <Handle type="target" position={Position.Left} id="apikey" style={{ top: '85%' }} />
            
            </div> */}

          <div>
              <label>Instruction .</label>
              {/* <input placeholder="Instruction" defaultValue={Instruction} onChange={handleChangeInstruction} /> */}
              <textarea
                onChange={handleChangeInstruction}
                value={Instruction}
                placeholder="Instruction"
                rows={3} 
                style={{ width: '100%' }} 
                className="nodrag f-10 border" 
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onDoubleClick={(e) => e.stopPropagation()}
                        />
              {/* <Handle type="target" position={Position.Left} id="Instruction" style={{ top: '85%' }} /> */}
            
            </div> 
            <Bottom_input selected_params={selected_output_param} onchange_selected_output_param={onchange_selected_output_param} />
        </div>

        {/* Handles with spaced top values */}
        
        
        {/* <Handle type="target" position={Position.Left} id="system" style={{ top: '40%' }} /> */}
        <Handle type="source" position={Position.Right} />
      </div>
    </div>
  );
};

export default OpenAINode;
